function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.371 7.334a2.691 2.691 0 00-2.07-.98h-4.104l.504-1.298a3.775 3.775 0 00-.436-3.454A3.708 3.708 0 008.2 0a.9.9 0 00-.82.536L4.816 6.354H2.7C1.21 6.354 0 7.573 0 9.076v6.354c0 1.504 1.209 2.723 2.7 2.723h11.458c1.304 0 2.42-.94 2.655-2.233l1.144-6.353a2.74 2.74 0 00-.586-2.233zm-12.87 9.004H2.7a.904.904 0 01-.9-.908V9.076c0-.5.402-.907.9-.907h1.8v8.169zM16.2 9.24l-1.143 6.353a.902.902 0 01-.9.745H6.301V7.452l2.448-5.555c.51.15.933.508 1.17.987A1.93 1.93 0 019.99 4.42l-.477 1.298c-.207.557-.13 1.18.206 1.67.336.488.887.78 1.477.78h4.104c.268 0 .522.12.693.328a.913.913 0 01.207.744z",
  fill: "currentColor",
  fillRule: "evenodd"
})));